import Button from "../Button/Button";
import { useTranslation } from "react-i18next";
import { useSetPosModal } from "@/shared/atoms/usePosModal";
import { useSetAtom } from "jotai";
import { editOrderAtom } from "@/shared/atoms";
import { OrderV2 } from "@/shared/v2/queries/interfacesV2";
import { DeliveryMethods } from "@/shared/utils/enum";
import useOrderHelper from "@/shared/v2/hooks/useOrderHelper";
import { cn } from "@/shared/utils/cn";

const OrderCardEditButton = ({ order }: { order: OrderV2 }) => {
  const { t } = useTranslation();
  const setPosModal = useSetPosModal();
  const setEditOrder = useSetAtom(editOrderAtom);
  const { delivery_method_id, order_session_id } = useOrderHelper(order);
  const isDineIn = delivery_method_id === DeliveryMethods.DINE_IN;
  const isSessionAndTakeoutOrder =
    Boolean(order_session_id) && delivery_method_id === DeliveryMethods.TAKEOUT;

  return (
    <Button
      size="small"
      variant="secondary"
      onClick={(e) => {
        e.stopPropagation();
        setPosModal(true);
        setEditOrder(order);
      }}
      className={cn(
        "px-2! py-2! 2xl:px-btn-small-x 2xl:py-btn-small-y",
        isDineIn || isSessionAndTakeoutOrder ? "hidden" : "block"
      )}
    >
      <span className="text-xl 2xl:text-2xl">{t("edit")}</span>
    </Button>
  );
};

export default OrderCardEditButton;
